import { ReactNode } from "react";

export interface ModalHeaderProps {
  title?: string;
  children?: ReactNode;
}

function ModalHeader({ title, children }: ModalHeaderProps) {
  return (
    <div className="border-0 modal-header">
      {children ? (
        children
      ) : (
        <div className="modal-title h4">{`تغییر عنوان ${title || ""}`}</div>
      )}
    </div>
  );
}

export default ModalHeader;
